module.exports = {
    en: {
        login: 'Login',
        register: 'Register',
        about: 'About',
        team: 'Team',
        pricing:'Pricing',
        constructionMsg: 'Our website is under construction right now, please come back later, thank you!',
        contactMsg:'Get connected with us on social networks!',
        overview:'Project Overview',
        overviewContent:'Deploying your project can be very cumbersome and confusing, especially for those who are inexperienced ' +
            'with deployment frameworks. Additionally, developing a deployment pipeline requires time and effort on the developers ' +
            'side, along with the necessity of maintaining the infrastructure. Our web application strives to automate the deployment' +
            ' process and abstract away the underlying details about deployment from start to finish. ' +
            'A user will be able to deploy multiple images that will have cross-container communication via automated orchestration tools. ' +
            'Additionally, we provide real-time monitoring of the provided infrastructure for users to view deployment progress ' +
            'and up to date statistics.',
        usecase:'Business Use Cases',
        usecaseContent:'Developers don\'t need to worry about the infrastructure needed for Cloud deployment. No manual configuration required like, auto scaling can be built in. Manage deployment status of multiple projects in one place. Bringing together a single deployment model for different kinds of projects. Takes care of full stack deployment. (different components of the product like backend, frontend)\n',
        goal:'Our Goal',
        goalContent:'Our goal is to provide the best service for businesses and individuals alike to focus on what they do best, with better resources, without worrying about the nitty-gritty details of infrastructure, allowing businesses to grow faster, smarter and better.\n',
        i18n: 'I18N Support Is Here',
        i18nContent: 'You can choose your language on our platform to begin and enjoy your app deployment journey',
        unlimited: "Unlimited number of deployments and project updates",
        limitAccess: "Limited access to cloud providers and services",
        download: "Download your deployment configurations to local",
        registerNow:'Register Now',
        free: 'FREE',
        vip: 'VIP',
        comingSoon: 'COMING SOON'
    }
};
